import { useFormContext, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { Button } from '@calendly/ui/components/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuGroupTitle, DropdownMenuItem, DropdownMenuTrigger } from '@calendly/ui/components/dropdown-menu';
import { IconChevronDown } from '@calendly/ui/components/glyphs/IconChevronDown';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { logoName } from './config';
import { SendFromOption } from './send_from_option';
import { FieldBlock } from './styles';
const sendContainerCss = "sazzdmy";
const SendContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sendContainerCss, props.className)} />;
});
const emailAddressCondensedCss = "e1xztvn5";
const EmailAddressCondensed = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(emailAddressCondensedCss, props.className)} />;
});
const styledLogoCss = "s1beitge";
const StyledLogo = forwardRef((props, ref) => <BrandLogo ref={ref} {...props} className={classNames(styledLogoCss, props.className)} />);
const senderWrapperCss = "s12d21b9";
const SenderWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(senderWrapperCss, props.className)} />;
});
const fromTextCss = "fyzy4tu";
const FromText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(fromTextCss, props.className)} />;
});
const styledButtonCss = "sd38m97";
const StyledButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
const fieldBlockNoSidePaddingCss = "fb4o23";
const FieldBlockNoSidePadding = forwardRef((props, ref) => <FieldBlock ref={ref} {...props} className={classNames(fieldBlockNoSidePaddingCss, props.className)} />);
export const SendWithField = ({
  emails,
  ...props
}) => {
  const [{
    name
  }] = useFormField(props);
  const {
    setFieldValue
  } = useFormContext();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const initialSelectedEmail = emails.length > 1 ? emails[1] : emails[0];
  const [selectedEmail, setSelectedEmail] = useState(initialSelectedEmail);
  const hasGmailConnected = emails.some(email => email.type === 'gmail');
  const hasOutlookConnected = emails.some(email => email.type === 'outlook');
  const handleToggleDropdown = () => {
    setIsDropdownOpen(open => !open);
  };
  const handleClickEmail = option => {
    setSelectedEmail(option);
    setFieldValue(name, {
      type: option.type,
      email: option.emailAddress
    });
    setIsDropdownOpen(false);
  };
  return <FieldBlockNoSidePadding data-component="send_with_field_block">
      <SendContainer>
        <SenderWrapper>
          <FromText> From: </FromText>
          <DropdownMenu isOpen={isDropdownOpen} onClose={() => setIsDropdownOpen(false)}>
            <DropdownMenuTrigger>
              <StyledButton decoration="ghost" onClick={handleToggleDropdown} aria-expanded={isDropdownOpen} aria-haspopup="menu">
                <StyledLogo name={logoName[selectedEmail.type]} />
                <EmailAddressCondensed>{selectedEmail.emailAddress}</EmailAddressCondensed>
                <UiIcon icon={IconChevronDown} size="small" title="" />
              </StyledButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent placement="bottom end">
              {emails.map(option => <DropdownMenuItem key={option.emailAddress} onSelect={() => {
              handleClickEmail(option);
            }}>
                  <SendFromOption {...option} />
                </DropdownMenuItem>)}
              {(!hasGmailConnected || !hasOutlookConnected) && <DropdownMenuGroup>
                  <DropdownMenuGroupTitle>
                    {I18n.t('publisher.send_from_calendly.send_with_dropdown.title')}
                  </DropdownMenuGroupTitle>
                  {!hasGmailConnected && <DropdownMenuItem href="https://calendly.com/integrations/gmail" target="_blank" rel="noreferrer">
                      <StyledLogo name={logoName.gmail} />
                      <BodyText size="medium">{I18n.t('publisher.send_from_calendly.send_with_dropdown.gmail_integration')}</BodyText>
                    </DropdownMenuItem>}
                  {!hasOutlookConnected && <DropdownMenuItem href="https://calendly.com/integrations/outlook" target="_blank" rel="noreferrer">
                      <StyledLogo name={logoName.outlook} />
                      <BodyText size="medium">{I18n.t('publisher.send_from_calendly.send_with_dropdown.outlook_integration')}</BodyText>
                    </DropdownMenuItem>}
                </DropdownMenuGroup>}
            </DropdownMenuContent>
          </DropdownMenu>
        </SenderWrapper>
      </SendContainer>
    </FieldBlockNoSidePadding>;
};

require("./send_with.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./send_with.js");